import { Env } from "../constants";
import { $axios } from "../constants/axios.instance";

/**
 * set access token in axios instance header
 */
export const setAuthorizationToken = (token?: string) => {
  if (token) {
    $axios.defaults.headers.common["access-token"] = token;
  } else {
    $axios.defaults.headers.common["access-token"] = "";
    delete $axios.defaults.headers.common["access-token"];
  }
};

export const removeSession = () => {
  localStorage.clear();
  setAuthorizationToken("");
  window.location.reload();
};

/**
 * get user access token form localstorage
 */
export const getSetAccessToken = () => {
  const accessToken = getAccessToken();
  if (accessToken) {
    setAuthorizationToken(accessToken);
  }
  return accessToken;
};

/**
 * get user access token form localStorage
 */
export const setAccessToken = (accessToken: any) => {
  if (accessToken) {
    setAuthorizationToken(accessToken);
  }
  return accessToken;
};

/**
 * get user id form localStorage
 */
export const getAccessToken = () => {
  const tokenObjectString = localStorage.getItem(
    `dynamic_${Env.ENVIRONMENT_ID}_session`,
  );
  const tokenObject = tokenObjectString && JSON.parse(tokenObjectString);
  const token = tokenObject?.value?.legacyToken;
  return token;
};

/**
 * get mfaToken form localStorage
 */
export const getMFAtoken = () => {
  return localStorage.getItem("mfaToken");
};
